import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function SenderAddressField(props) {
    return (
        <FormikInput
            name={'senderAddress'}
            label={'shippingMethods.form.field.senderAddress.label'}
            placeholder={'shippingMethods.form.field.senderAddress.placeholder'}
            required={true}
        />
    );
}

export default SenderAddressField;
